module.exports = __webpack_public_path__ + "static/media/closeSlid.2b424bbd.svg";